import styled, { keyframes } from 'styled-components';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';

const flashesEffect = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: .15;
  }
`;

export const AddToQueueIconCustom = styled(AddToQueueIcon)`
  &.flashes {
    color: #e53935;
    animation: ${flashesEffect} 0.8s linear infinite;
  }
`;

const pulse = keyframes`
  0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 #F64444;
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`;

export const Blob = styled.div`
  background: ${({ theme }) => theme.colors.red};
  border-radius: 50%;
  margin: 4px;
  height: 10px;
  width: 10px;

  box-shadow: 0 0 0 0 ${({ theme }) => theme.colors.red};
  transform: scale(1);
  animation: ${pulse} 2s infinite;
`;

export const blink = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const Border = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100% + 6px);
  left: 0;
  top: -3px;
  border: 3px solid ${({ theme }) => theme.colors.red};
  animation: 1s ${blink} ease-out infinite;
`;
